export const STOCK_AGE_BUCKETS = [
  {
    id: "fresh",
    label: "0–30 Tage",
    min: 0,
    max: 30,
    color: "#2e7d32",
    bg: "#e8f5e9",
  },
  {
    id: "moderate",
    label: "30–90 Tage",
    min: 30,
    max: 90,
    color: "#ed6c02",
    bg: "#fff3e0",
  },
  {
    id: "aging",
    label: "90–180 Tage",
    min: 90,
    max: 180,
    color: "#d32f2f",
    bg: "#ffebee",
  },
  {
    id: "stale",
    label: "180+ Tage",
    min: 180,
    max: Infinity,
    color: "#6a1b9a",
    bg: "#f3e5f5",
  },
];

export const NO_SALE_BUCKET = {
  id: "never",
  label: "Kein Verkauf",
  color: "#757575",
  bg: "#f5f5f5",
};

export function getStockAgeBucket(daysSinceLastSale) {
  if (daysSinceLastSale == null || Number.isNaN(daysSinceLastSale)) {
    return NO_SALE_BUCKET;
  }
  const days = Number(daysSinceLastSale);
  return (
    STOCK_AGE_BUCKETS.find((b) => days >= b.min && days < b.max) ??
    STOCK_AGE_BUCKETS[STOCK_AGE_BUCKETS.length - 1]
  );
}

export function countByStockAgeBucket(items) {
  const counts = {
    fresh: 0,
    moderate: 0,
    aging: 0,
    stale: 0,
    never: 0,
  };
  for (const item of items) {
    const bucket = getStockAgeBucket(item.days_since_last_sale);
    counts[bucket.id] = (counts[bucket.id] ?? 0) + 1;
  }
  return counts;
}
